"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var BootstrapHelper_1 = require("../../BootstrapHelper");
var Avatar = function (props) {
    var cls = (0, BootstrapHelper_1.B)()
        .bl("avatar")
        .pmod(props.type || "primary")
        .pmod(props.size || "md")
        .pmod(props.borderType || "").bem;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "".concat(cls, " ").concat(props.className || "") }, { children: [props.imgLink ? ((0, jsx_runtime_1.jsx)("a", __assign({ href: props.imgLink }, { children: (0, jsx_runtime_1.jsx)("div", { className: "avatar__content", style: {
                        backgroundImage: "url('".concat(props.imgSrc, "')")
                    } }) }))) : ((0, jsx_runtime_1.jsx)("div", { className: "avatar__content", style: { backgroundImage: "url(\"".concat(props.imgSrc, "\")") } })), props.hoverLabel && (0, jsx_runtime_1.jsx)("div", __assign({ className: "avatar__label" }, { children: props.hoverLabel }))] })));
};
exports.Avatar = Avatar;
